<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <i class="pi pi-exclamation-triangle not-found-icon" />
      <h1>404</h1>
      <h2>Seite nicht gefunden</h2>
      <UiInfoButton title="Hilfe: Seite nicht gefunden">
        <ul>
          <li>Die gewünschte Adresse ist nicht verfügbar oder veraltet.</li>
          <li>Klicke auf „Zurück zur Startseite“, um wieder ins System zu gelangen.</li>
          <li>Über die Navigation findest du alle verfügbaren Bereiche.</li>
        </ul>
      </UiInfoButton>
      <p>Die angeforderte Seite existiert nicht oder wurde verschoben.</p>
      <PrimeButton
        label="Zurück zur Startseite"
        icon="pi pi-home"
        @click="goToHome"
      />
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import PrimeButton from 'primevue/button';
import UiInfoButton from '@/components/UiInfoButton.vue';

export default {
  name: 'NotFound',
  components: {
    PrimeButton,
    UiInfoButton
  },
  setup() {
    const router = useRouter();

    const goToHome = () => {
      router.push({ name: 'Dashboard' });
    };

    return {
      goToHome
    };
  }
};
</script>

<style lang="scss" scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  padding: 2rem;

  .not-found-content {
    max-width: 500px;

    .not-found-icon {
      font-size: 5rem;
      color: var(--primary-color);
      margin-bottom: 1rem;
    }

    h1 {
      font-size: 4rem;
      margin: 0;
      color: var(--primary-color);
    }

    h2 {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
    }

    p {
      margin-bottom: 2rem;
      color: var(--text-color-secondary);
    }
  }
}
</style>
